import { createRouter, createWebHistory } from "vue-router";

import AssessmentView from "./views/AssessmentView.vue";
import JoinView from "./views/JoinView.vue";
import SummaryView from "./views/SummaryView.vue";

export default createRouter({
  history: createWebHistory(),
  routes: [
    { path: "/", component: JoinView },
    { path: "/assessment/:token", component: AssessmentView },
    { path: "/summary/:token", component: SummaryView },
  ],
});
